<ng-template #receiptTemplate let-receipt>
	<div class="typo-container-s-s-q typo-small"
	     *ngIf="!receipt.rcptStatement">
    <span class="">
      {{enumSvc.getEnumerationText('ReceiptStatus', receipt?.rcpt_enmIdent_ReceiptStatus)}}
      - {{enumSvc.getEnumerationText('ReceiptType', receipt?.rcpt_enmIdent_ReceiptType)}}
    </span>
		<span></span>
		<q></q>
		<span class="app-list-row-boldline">
      {{receipt.rcptDate | excDate: 'dd.MM.yyyy'}}
			{{!receipt.rcptDate ? getRessource('EmptyColumn.rcptDate') : ''}}&nbsp;|&nbsp;
			{{receipt.compName && receipt.compName.length > 0 ? receipt.compName :
        getRessource('EmptyColumn.compName')}}
    </span>
		<span></span>
		<q></q>
		<span>
      {{getObjectString(receipt)}}
    </span>
		<span></span>
		<q></q>
		<ng-container *ngIf="receipt.rcptReviewReasons">
      <span class="list-secondary-text app-list-text"
            [tooltip]="getReviewReasonsText(receipt.rcptReviewReasons).length >= 48 ? getReviewReasonsText(receipt.rcptReviewReasons) : ''">
        {{getRessource('ReviewReasons')}}:
        {{ getReviewReasonsText(receipt.rcptReviewReasons).slice(0, 48) }}{{ getReviewReasonsText(receipt.rcptReviewReasons).length >= 48 ? '...' : '' }}
      </span>
			<span></span>
			<q></q>
		</ng-container>
		<ng-container *ngIf="receipt.rcptNetSum || receipt.rcptGrossSum">
      <span class="list-secondary-text app-list-text">
        {{getRessource('GrossSum')}}: {{receipt.rcptGrossSum !== null ? (receipt.rcptGrossSum | excCurrency:'€') :'-'}} |
        {{getRessource('TotalCorrections')}}: {{receipt.rcptTotalCorrections !== null ? (receipt.rcptTotalCorrections | excCurrency:'€') :'-'}}
      </span>
			<span></span>
			<q></q>
		</ng-container>
		<ng-container *ngIf="receipt.rcptDesc?.toString().length > 0">
      <span class="list-secondary-text app-list-text">
        {{receipt.rcptDesc?.toString().slice(0, 64)}}{{receipt.rcptDesc?.length >= 64 ? '...' : ''}}
      </span>
			<span></span>
			<q></q>
		</ng-container>
	</div>
</ng-template>
<ng-template #receiptStatementTemplate let-receipt>
	<div class="typo-container-s-s-q typo-small"
	     *ngIf="receipt.rcptStatement">
    <span class="">
      {{enumSvc.getEnumerationText('ReceiptStatus', receipt?.rcpt_enmIdent_ReceiptStatus)}}
    </span>
		<span></span>
		<q></q>
		<ng-container *ngIf="receipt.rcptStatementReason?.toString().length > 0">
      <span class="app-list-text">
        {{
		      receipt.rcptStatementReason.slice(0, 64)}}{{receipt.rcptStatementReason.length >= 64 ? '...' : ''
	      }}
      </span>
			<span></span>
			<q></q>
		</ng-container>
		<ng-container *ngIf="receipt.rcptStatementText?.toString().length > 0">
      <span class="list-secondary-text app-list-text">
        {{stripHtmlTags(receipt.rcptStatementText).slice(0, 64)}}
	      {{stripHtmlTags(receipt.rcptStatementText).length >= 64 ? '...' : ''}}
      </span>
			<span></span>
			<q></q>
		</ng-container>
	</div>
</ng-template>

<div class="layout-auto-1">
	<div *ngIf="ConfigReceiptTable.state === 2" class="splash empty">
		<p>{{getTranslation('Es wurden keine Daten gefunden!')}}</p>
	</div>
	<div class="content"
	     *ngIf="ConfigReceiptTable.state === 0">
		<cdk-tree [dataSource]="SummaryReceiptTable.data"
							[treeControl]="ConfigReceiptTable.treeControl">
			<cdk-nested-tree-node
				*cdkTreeNodeDef="let receipt"
			  class="example-tree-node">
				<div class="list-row list-row-1-auto app-list app-cursor-pointer"
				     (click)="receipt.rcptStatement ? localConfig.openStatementCheckview(receipt.rcptID) : localConfig.openReceiptCheckview(receipt.rcptID)">
					<ng-container *ngTemplateOutlet="receiptTemplate; context: {$implicit: receipt}"></ng-container>
					<ng-container *ngTemplateOutlet="receiptStatementTemplate; context: {$implicit: receipt}"></ng-container>
					<div class="list-metadata ">
						<div class="typo-right">{{receipt.rcptLCD | excDate: 'Globals.DateTimeFormatShort'}}</div>
						<div class="typo-right">{{receipt.rcptLCU}}</div>
						<div class="typo-right app-space-top_1">
							<i class="search-action fa-trash-alt" style="margin-bottom: .5rem"
							   [class.fa-duotone]="receipt.rcpt_enmIdent_ReceiptStatus <= 2 || excSecurity.isFeatured('RECEIPTDELETE')"
							   [class.fa-regular]="!(receipt.rcpt_enmIdent_ReceiptStatus <= 2 || excSecurity.isFeatured('RECEIPTDELETE'))"
							   [class.disabled]="!(receipt.rcpt_enmIdent_ReceiptStatus <= 2 || excSecurity.isFeatured('RECEIPTDELETE'))"
							   (click)="ConfigReceiptTable.deleteReceipt($event, receipt.rcptID, receipt.rcptUPT, receipt.rcpt_enmIdent_ReceiptStatus)">
							</i>
						</div>
					</div>
				</div>
			</cdk-nested-tree-node>
			<cdk-nested-tree-node *cdkTreeNodeDef="let node; when: ConfigReceiptTable?.hasChild"
			                      class="example-tree-node">
				<div class="list-row app-cursor-pointer" cdkTreeNodeToggle
				     (click)="localConfig.refreshLoading()"
				>
					<div class="grid-auto-1" style="padding:0.5rem">
						<div class="list-avatar nobackground">
							<i class="far fa-fw"
							   [class.fa-folder-open]="ConfigReceiptTable?.treeControl.isExpanded(node)"
							   [class.fa-folder]="!ConfigReceiptTable?.treeControl.isExpanded(node)"
							></i></div>
						<div [class.layout-auto-1]="!node.refGroupStatement">
							<div class="grid-1-auto"
							     style="margin-left: 0">
								<div>
									{{node.refGroupHeadline && node.refGroupHeadline.length >= 0 ? node.refGroupHeadline : node.refGroupStatement ? getGlobal('ReceiptStatement') : getRessource('noGroupDesc')}}
								</div>
								<div class="spawn list-metadata">
									{{node.refItem_rcptIDs}} {{node.refGroupStatement ? getGlobal('ReceiptStatements') : getGlobal('Receipt')}}
								</div>
							</div>
							<div class="list-metadata"
							     *ngIf="!node.refGroupStatement"
							     style="margin-left: 0">
								{{node.refGroupHeadline && node.refGroupHeadline.length >= 0 ? node.refGroupDesc: getRessource('noGroupDesc')}}
							</div>
						</div>
					</div>
				</div>
				<div [hidden]="!ConfigReceiptTable?.treeControl.isExpanded(node)">
					<ng-container cdkTreeNodeOutlet></ng-container>
				</div>
			</cdk-nested-tree-node>
		</cdk-tree>
	</div>
</div>
